<template>   
  <div :class="type" class="">
    <!-- MOBILE -->
    <template v-if="type == 'mobile-info'" :class="{ 'removeActive': removeActive == true }">
      <div :class="{ 'removeActive': removeActive == true }">
        <div @click="itemClick(index)" class="mobile-acc pointer" :class="{ 'active': active == true }" :style="top(index)">
          <div class="flex flex-row items-center justify-between pointer mobile-title container-fluid">
            <slot name="parent-nav-link"></slot>
            <div class="w2 inline-flex pointer arrow-down-icon" :class="{ 'is-clicked': mobileActive == index, 'is-navy': isInfoPage }">
              <simple-svg class="green-arrow"
                :filepath="'/uploads/plus.svg'"
                :id="'arrow-down-icon-id'">
              </simple-svg>
            </div>
          </div>
        </div>
        <div ref="mobileFAQsContainer" class="relative overflow-x-hidden overflow-y-scroll info-height mobile-info-height-container" :class="{ 'active': active == true }">
          <transition @beforeEnter="beforeEnter" @enter="enter" @leave="leave">
            <div class="info" :class="{ 'active': mobileActive == index}"  v-show="mobileActive == index">
              <slot name="sub-nav-links"></slot>
            </div>
          </transition>
        </div>
      </div>
    </template>
    <template v-else-if="type == 'desktop-info'">
      <div class="mobile-info" @click="active = !active"  :class="{ 'removeActive': removeActive == true }">
        <div @click="itemClick(index); faqExpand();" class="desktop-acc pointer" :class="{ 'active': active == false }">
          <div class="flex flex-row items-center justify-between pointer">
            <slot name="parent-nav-link"></slot>
            <div class="w2-ns w1 inline-flex pointer arrow-down-icon" :class="{ 'is-clicked': mobileActive == index }">
               <div class="circle-plus closed" :class="{ 'opened': active == false }">
                <div class="circle">
                  <div class="horizontal"></div>
                  <div class="vertical"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="relative overflow-hidden info-height" v-if="!active" :class="{ 'active': mobileActive == index}">
          <transition @beforeEnter="beforeEnter" @enter="enter" @leave="leave">
            <div class="info-slide" :class="{ 'active': mobileActive == index}"  v-show="mobileActive == index">
              <slot name="sub-nav-links"></slot>
            </div>
          </transition>
        </div>
      </div>
    </template>
    <!-- DESKTOP -->
    <template v-else>
      <div @click="itemClick(index, link)" class="flex flex-row items-center justify-between pointer acc-menu" :class="{ '': index !== 0 }">
        <slot name="parent-nav-link"></slot>
        <div class="w2 inline-flex pointer arrow-down-icon" :class="{ 'is-clicked': desktopActive == index }"></div>
      </div>
      <transition name="slide-fade">
        <div class="info relative" :class="{ 'active': desktopActive == index}"  v-show="desktopActive == index">
          <slot name="sub-nav-links"></slot>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
  export default {
    data () {
      return {
        subNavMenuItemClicked: false,
        active: false,
        removeActive: false,
        currentActive:null,
        isInfoPage: false
      }
    },
    props: {
      type:{},
      index:{},
      link:{},
      mobileActive:{},
      desktopActive:{},
      desktopActive2:{},
      resizing:{},
      closed:{},
      mobileFaqAnswerExpanded: false
    },
    methods: {
      itemClick(index, link){
        if (this.type == 'mobile-info'){
          if(this.mobileActive == index){
              var accTop = this.$el.getBoundingClientRect().top - 46;
              if(accTop < 0){
                var top = window.pageYOffset + this.$el.getBoundingClientRect().top - 46;
                window.scrollTo(0, top);
              }
              this.$emit('update:mobileActive', -1);
            } else
              this.$emit('update:mobileActive', index);
        } else if (this.type == 'dektop-info'){
          console.log('FAQ Item clicked')
          this.active = true;

        } else{
          if(this.desktopActive !== index){
            this.$emit('update:desktopActive', index);
            this.$emit('update:desktopActive2', 0);
            //this.
            window.scrollTo(0, top);
            // this.$router.push({ path: '/experience/'+link })
          }
        }
      },
      faqExpand() {
        console.log('faqExpand', this)
        /*this.mobileFaqAnswerExpanded = !this.mobileFaqAnswerExpanded;
        console.log('faqExpand()', this.mobileFaqAnswerExpanded)
        this.$emit('update:mobileFaqAnswerExpanded', this.mobileFaqAnswerExpanded);*/
      },
      top(index){
        var self = this;
        if(this.mobileActive < 0){
          self.active = false;
          setTimeout(function(){
            self.removeActive = false;
          },1);
          return 'top:'+(index * 68)+'px';
        } else if(this.mobileActive == index){
          setTimeout(function(){
            self.active = true;
            self.removeActive = true;
          }, 400);
          return 'top:0px;z-index:10;';
        } else {
          self.active = false;
          return 'top:0px;';
        }
      },
      beforeEnter(el){ 
        el.style.top = '-100px';
        el.parentElement.style.height = '0';
        },
      enter(el, done){
        var self = this;
        let top = '0px';
        el.parentElement.style.height = 'auto';
        //RESIZE MOBILE EXP ITEMS
        if(this.resizing){
          this.resizing.map(function(value, key) {
            var height = value.children[0].getBoundingClientRect().height;
            if (height == 0)
              height = value.children[1].getBoundingClientRect().height;
            value.style.height = (height + 300) + 'px';
          });
        }
        var height = el.getBoundingClientRect().height;
        el.parentElement.style.height = '0';
        this.currentActive = el.parentElement;
        Velocity(el, "stop")
        Velocity(el.parentElement, "stop")
        Velocity(el, {top}, {duration: 400, complete: done}, { loop: true })
        Velocity(el.parentElement, {height}, {duration: 400, complete: done}, { loop: true })
      },
      leave(el, done){
        let top = '-100px';
        let height = 0;
        this.currentActive = null;
        Velocity(el, "stop")
        Velocity(el.parentElement, "stop")
        Velocity(el, {top}, {duration: 400, complete: done}, { loop: true })
        Velocity(el.parentElement, {height}, {duration: 400, complete: done}, { loop: true })
      },
      resize(){
        if (this.currentActive){
          var height = this.currentActive.children[0].getBoundingClientRect().height;
          Velocity(this.currentActive, {height}, {duration: 0}, { loop: true })
        }
      }
    },
    created() {
      /* Check for info page for expand/collapse button colors */
      if(this.$route.path.includes('/info')) {
        this.isInfoPage = true;
      }
      window.addEventListener('resize', this.resize);
      window.addEventListener('load', this.resize);
      if(this.closed == true){
        this.active = true;
      }
    },
    destroyed() {
      window.removeEventListener('resize', this.resize)
      window.removeEventListener('load', this.resize);
    }
  }
</script>